if (!customElements.get('toast-alert')) {
  class ToastAlert extends HTMLElement {
    constructor() {
      super();
      this.mode = this.getAttribute('data-mode');
      this.modal = this.querySelector('[data-modal]');
      this.icon = this.querySelector('[data-icon]');
      this.message = this.querySelector('[data-message]');
      this.close = this.querySelector('[data-close]');

      this.defaultError = 'Oops! Something went wrong';
    }

    connectedCallback() {
      document.addEventListener('ERROR', this.handleError.bind(this));
      document.addEventListener('SUCCESS', this.handleSuccess.bind(this));
      document.addEventListener('PROMOTION', this.handlePromotion.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('ERROR', this.handleError.bind(this));
      document.removeEventListener('SUCCESS', this.handleSuccess.bind(this));
      document.removeEventListener('PROMOTION', this.handlePromotion.bind(this));
    }

    handleError(e) {
      const description = e.detail?.description || this.defaultError;
      this.show('error', description);
    }

    handleSuccess(e) {
      const description = e.detail?.description;
      if (!description) return;
      this.show('success', description);
    }

    handlePromotion(e) {
      const description = e.detail?.description;
      if (!description) return;
      this.show('promotion', description);
    }

    show(type, description) {
      let className = 'toast-alert toast-alert--notification';
      switch (type) {
        case 'error':
          className = 'toast-alert toast-alert--error';
          break;
        case 'success':
          className = 'toast-alert toast-alert--success';
          break;
        case 'promotion':
          className = 'toast-alert toast-alert--promotion';
          break;
        default:
          break;
      }

      this.message.innerHTML = description;

      Toastify({
        node: this.modal,
        className,
        position: 'center',
        offset: {
          y: '20vh',
        },
        style: {
          background: null,
          borderRadius: '12px',
          zIndex: 100,
        },
        close: true,
        duration: 3000,
      }).showToast();
    }
  }

  customElements.define('toast-alert', ToastAlert);
}
